/** A driver's own page gives each tab its own route, `/drivers/:id/<tab>` (`recordTabRoutes`). */
export const DRIVER_TABS = ['details', 'documents', 'history'] as const;
export type DriverTab = (typeof DRIVER_TABS)[number];

export const DRIVER_TAB_LABELS: Record<DriverTab, string> = { details: 'Details', documents: 'Documents', history: 'History' };

export function driverPath(id: string): string {
  return `/drivers/${id}`;
}

export function driverTabPath(id: string, tab: DriverTab): string {
  return `${driverPath(id)}/${tab}`;
}
